import React, { ReactElement, FC } from 'react'

const SourceMidRenderLightIcons: FC = (): ReactElement => {
  return <div>Placeholder Component</div>
}

export default SourceMidRenderLightIcons
